import React from "react";
import FontAwesome from 'react-fontawesome';
import styles from './WeekView.less';

const Equipment = ({ equipment, active, onEquipmentSelect}) => equipment? (

        <div className={[styles.crewTag,  active ? styles.active : ''].join(' ')} onClick={onEquipmentSelect}  >
        <FontAwesome name="equipment" style={{ color: '#fafafa' }} /> 
        
    <span>{equipment.name}<br />
    </span> 
    
    </div>):(
    <div className={[styles.crewTag, active ? styles.active : ''].join(' ')} onClick={onEquipmentSelect}>Unassigned</div>
  );


export default Equipment;